/**
 * NADRA CNIC / B-Form helpers. Values are stored as 13 bare digits; these
 * only shape what people see.
 */

/** Digits only, capped at 13 — what gets stored. */
export const cnicDigits = (value: string | null | undefined): string =>
  (value || '').replace(/\D/g, '').slice(0, 13);

/** Dashes in NADRA's 5-7-1 layout, applied progressively so it also works
 *  as a live input mask ("35202" → "35202-1" → … → "35202-1234567-1"). */
export const formatCnic = (value: string | null | undefined): string => {
  const d = cnicDigits(value);
  if (d.length <= 5) return d;
  if (d.length <= 12) return `${d.slice(0, 5)}-${d.slice(5)}`;
  return `${d.slice(0, 5)}-${d.slice(5, 12)}-${d.slice(12)}`;
};
